import React, { HTMLAttributes, InputHTMLAttributes } from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ margin?: string }>`
  width: 100%;
  margin-bottom: ${({ margin }) => (margin ? margin : "20px")};
`;

const Input = styled.input`
  height: 42px;
  border: 1px solid #c9c9c9;
  width: 100%;
  font-size: 14px;
  color: #080808;
  opacity: 0.8;
  font-weight: normal;
  padding: 0px 10px;
  border-radius: 0px;
  box-sizing: border-box;
`;

const Label = styled.label`
  display: flex;
  font-weight: bold;
  margin-bottom: 5px;
  color: #080808;
  font-size: 14px;
`;

function TextInput({
                     margin,
                     wrapperStyle,
                     inputLabel,
                     error,
                     ...rest
                   }: ITextInput) {
  return (
    <Wrapper margin={margin} style={wrapperStyle}>
      {inputLabel && <Label htmlFor={"input-" + rest.name}>{inputLabel}</Label>}
      <Input id={"input-" + rest.name} {...rest} />
      {error && <span style={{ color: "red" }}>{error}</span>}
    </Wrapper>
  );
}

export interface ITextInput extends InputHTMLAttributes<HTMLInputElement> {
  inputLabel?: string;
  margin?: string;
  wrapperStyle?: React.CSSProperties;
  error?: string | null;
}

export default TextInput;
